import { Input, Output, EventEmitter, Directive, TemplateRef, ContentChild } from '@angular/core';

@Directive({
    selector: "[accordionContent]",
    standalone: false
})
export class AccordionContentDirectiveLegacy {
  constructor(public templateRef: TemplateRef<any>) {}
}

@Directive({
    selector: 'bw-accordion-item-legacy',
    standalone: false
})
export class AccordionItemDirectiveLegacy {

  @Input() title = "";
  @Input() disabled = false;
  @Output() collapsed = new EventEmitter<boolean>();
  @ContentChild(AccordionContentDirectiveLegacy) content: AccordionContentDirectiveLegacy;

}
